import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=3da39f62&"
import script from "./CustomPopup.vue?vue&type=script&lang=js&"
export * from "./CustomPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomPopup.vue?vue&type=style&index=0&id=3da39f62&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports